export const isFitmentContextUpdated = (
  shouldHideProductCardFitment: boolean,
  products: Product[],
  fitmentResponse: ProductFitmentResponse
): boolean => {
  let isCtxUpdated = shouldHideProductCardFitment;
  const fitmentKeysArray = Object.keys(fitmentResponse ?? {});
  if (!shouldHideProductCardFitment) {
    for (const fitmentKey of fitmentKeysArray) {
      isCtxUpdated = products?.some(
        ({ partNumber }) => partNumber === fitmentKey.toString()
      );
      if (isCtxUpdated === false) {
        break;
      }
    }
  } else if (shouldHideProductCardFitment && fitmentResponse) {
    isCtxUpdated = false;
  }
  return isCtxUpdated;
};
